<template>
  <v-snackbar
    v-model="snackbar.show"
    :color="snackbar.color"
    :top="snackbar.y === 'top'"
    :right="snackbar.x === 'right'"
    :left="snackbar.x === 'left'"
    :bottom="snackbar.y === 'bottom'"
    :multi-line="true"
    :timeout="snackbar.timeout"
  >
    <v-icon
      left
      color="white"
      class="mr-3"
      v-show="snackbar.messageIcon"
    >
    {{ snackbar.messageIcon }}
    </v-icon>
    {{ snackbar.message }}
    <v-btn
      dark
      flat
      @click="!snackbar.button.cb ? toggleSnackbar() : snackbar.button.cb"
      v-show="snackbar.button.show"
    >
      {{ snackbar.button.text }}
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'docgo-snackbar',
  computed: {
    snackbar() {
      return this.$store.getters.snackbar;
    },
  },
  methods: {
    toggleSnackbar() {
      this.$store.dispatch('toggleSnackbar', { show: false });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/base/DocgoSnackbar.vue